import { render, staticRenderFns } from "./learningReport.vue?vue&type=template&id=e23cb162&scoped=true"
import script from "./learningReport.vue?vue&type=script&lang=js"
export * from "./learningReport.vue?vue&type=script&lang=js"
import style0 from "./learningReport.vue?vue&type=style&index=0&id=e23cb162&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23cb162",
  null
  
)

export default component.exports